"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _SettingsPage = _interopRequireDefault(require("settings-ui-nav/SettingsPage"));

var _usageTracker = _interopRequireDefault(require("settings-ui-sdk/utils/usageTracker"));

var _selectors = require("settings-ui-sdk/Routes/selectors");

var _reactRouterRedux = require("react-router-redux");

var _NotificationList = _interopRequireDefault(require("ReduxMessenger/components/NotificationList"));

var _urls = require("settings-ui-sdk/utils/urls");

var _reactDnd = require("react-dnd");

var _reactDndHtml5Backend = _interopRequireDefault(require("react-dnd-html5-backend"));

var _redux = require("redux");

function localNavigate(hrefHandler, appBasePath, childRoutes) {
  var routes = childRoutes.map(function (_ref) {
    var path = _ref.path;
    return path;
  });
  return function (evt, navItem) {
    if (navItem.path.indexOf(appBasePath) === 0) {
      var regExp = new RegExp(appBasePath + "/(.+?)/.*");
      var baseRoute = regExp.exec(navItem.path);
      var localPath = navItem.path.replace(appBasePath, '');

      if (baseRoute && baseRoute.length > 1) {
        var modulePath = baseRoute[1];

        if (routes.indexOf(modulePath) >= 0) {
          evt.preventDefault();
          hrefHandler(localPath);
        }
      }
    }
  };
}

var SettingsApplication =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(SettingsApplication, _Component);

  function SettingsApplication() {
    (0, _classCallCheck2.default)(this, SettingsApplication);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SettingsApplication).apply(this, arguments));
  }

  (0, _createClass2.default)(SettingsApplication, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          pathname = _this$props.pathname,
          rootUrl = _this$props.rootUrl,
          route = _this$props.route,
          dispatch = (0, _objectWithoutProperties2.default)(_this$props, ["children", "pathname", "rootUrl", "route"]);
      return _react.default.createElement(_SettingsPage.default, {
        pathname: pathname,
        onClickHandler: localNavigate(dispatch.push, rootUrl, route.childRoutes),
        appName: "settings-ui",
        track: _usageTracker.default.track
      }, _react.default.createElement("div", null, _react.default.createElement(_NotificationList.default, null), children));
    }
  }]);
  return SettingsApplication;
}(_react.Component);

SettingsApplication.propTypes = {
  children: _react.PropTypes.node.isRequired,
  pathname: _react.PropTypes.string.isRequired,
  rootUrl: _react.PropTypes.string.isRequired,
  route: _react.PropTypes.object.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    pathname: (0, _selectors.getFullPathFromRouting)(state),
    rootUrl: (0, _urls.getRootUrl)()
  };
};

var _default = (0, _redux.compose)((0, _reactDnd.DragDropContext)(_reactDndHtml5Backend.default), (0, _reactRedux.connect)(mapStateToProps, {
  push: _reactRouterRedux.push
}))(SettingsApplication);

exports.default = _default;
module.exports = exports.default;